import { useTranslation } from 'react-i18next';
import { OverlayNames, useOverlayManager } from '@/hooks/useOverlayManager';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import type { Event } from '@/types/event';
import { initialReportEventDrafts } from '@/utils/report-event-draft';
import { AddToReportSubmenuContent } from './AddToReportSubmenuContent';

interface AddEventToReportPickerProps {
    event: Event;
    confidence?: number;
    query?: string | null;
    onClose?: () => void;
}

export function AddEventToReportPicker({
    event,
    confidence,
    query,
    onClose,
}: AddEventToReportPickerProps) {
    const { t } = useTranslation(I18nNamespace.EVENTS);
    const { open } = useOverlayManager();

    return (
        <AddToReportSubmenuContent
            onSelect={(report) =>
                open(OverlayNames.ADD_EVENTS_TO_REPORT, {
                    report,
                    drafts: initialReportEventDrafts({
                        candidates: [{ event, confidence }],
                        t,
                        query,
                    }),
                })
            }
            onClose={onClose}
        />
    );
}
